import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './CookieConsentDialogStyles'
import { Button, Link } from '@material-ui/core'
const useStyles = makeStyles(styles)

const getCookie = (name) => {
    const match = document.cookie.split("; ").find(row => row.startsWith(`${name}=`));
    return match ? match.split("=")[1] : null;
};

const setCookie = (name, value) => {
    let domain = window.ENVIRONMENT.cookieConsent.Domain;
    let expireIn = window.ENVIRONMENT.cookieConsent.ExpireInSeconds ?? 31536000; // Defaults to 365 days.
    document.cookie = `${name}=${value}; ${(domain ? `domain=${domain};` : '')} path=/; max-age=${expireIn};`;
};

const CookieConsentDialog = ({ }) => {
    const consentCookieName = '.AspNet.Consent';
    const classes = useStyles(styles)

    const [isVisible, setIsVisible] = useState(() => {
        return !getCookie(consentCookieName);
    });

    const handleAccept = () => {
        setCookie(consentCookieName, "yes");
        setIsVisible(false);
    };

    const handleDeny = () => {
        setCookie(consentCookieName, "no");
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className={classes.cookieBannerCurtain}>
            <section id="cookie-banner" className={classes.cookieBanner}>
                <h1>Manage Consent</h1>
                <p>To provide the best experiences, we use technologies like cookies to store and/or access device information. Consenting to these technologies will allow us to process data such as browsing behaviour or unique IDs on this site. Not consenting or withdrawing consent, may adversely affect certain features and functions.</p>

                <section className={classes.cookieTypeContainer}>
                    <header>
                        <h1>Functional</h1>
                        <span className={classes.alwaysEnabledIndicator}>Always Enabled</span>
                    </header>
                    <p>The technical storage or access is strictly necessary for the legitimate purpose of enabling the use of a specific service explicitly requested by the subscriber or user, or for the sole purpose of carrying out the transmission of a communication over an electronic communications network.</p>
                </section>

                <section className={classes.cookieTypeContainer}>
                    <header>
                        <h1>Analytical</h1>
                    </header>
                    <p>These cookies allow us to measure and improve the performance of our website. They help us understand which pages are most and least popular and see how visitors move around the site, so we can make it better for everyone.</p>
                </section>

                <p className={classes.actionsContainer}>
                    <Button
                        id="cookies-accept"
                        variant="contained"
                        size="medium"
                        color="primary"
                        className={classes.submit}
                        onClick={handleAccept}
                    >
                    Accept
                    </Button>
                    &nbsp;&nbsp;
                    <Button
                        id="cookies-reject"
                        variant="contained"
                        size="medium"
                        color="secondary"
                        className={classes.submit}
                        onClick={handleDeny}
                    >
                    Deny
                    </Button>
                </p>

                <div className={classes.policyLinks}>
                    <Link href="https://www.compleatsoftware.com/cookie-policy-uk/" color="primary">
                        Cookie Policy
                    </Link>&nbsp;&nbsp;
                    <Link href="https://www.compleatsoftware.com/terms-conditions/privacy-policy/" color="primary">
                        Privacy Statement
                    </Link>
                </div>
            </section>
        </div>
    )
}

export default CookieConsentDialog